export const websiteUrl = 'https://sachso.edu.vn';
export const sachsoServerUrl = 'https://server.sachso.edu.vn';
export const hanhtrangsoUrl = 'https://hanhtrangso.edu.vn';
export const cdnServerUrl = 'https://cloud.softech.vn';
export const socketServerUrl = 'https://socket.sachso.edu.vn';
